export default __webpack_public_path__ + "static/media/CL.9ab88517.svg";